module.exports = __webpack_public_path__ + "static/linkedin-004a268c1b25acbbd6088a9f3f6f4bde.svg";